import type { ReduxAction } from '../../types';
import { Set } from 'immutable';
import { ID } from '@segment/analytics-next';
import Contact from '@models/Contact';

export interface ArchiveViewState {
  selectedContact: Contact | null;
  selectedContactBatch: Set<ID>;
}

const initialArchiveViewState = {
  selectedContact: null,
  selectedContactBatch: Set<ID>(),
};

export function archiveViewReducer(
  state: ArchiveViewState = initialArchiveViewState,
  { type, payload }: ReduxAction,
) {
  switch (type) {
    case 'SET_SELECTED_ARCHIVED_CONTACT':
      return {
        ...state,
        selectedContact: payload.contact,
      };

    case 'SET_SELECTED_ARCHIVED_CONTACT_BATCH':
      return {
        ...state,
        selectedContactBatch: payload.contactBatch,
      };

    default:
      return state;
  }
}
